export const rotateIcon = (isDropOpen: boolean) =>
  `${isDropOpen ? 'rotate-180' : ''}`;

export const toggleDropdown = (isDropOpen: boolean) =>
  `${isDropOpen ? 'block' : 'hidden'}`;
